export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/2cb37da391587709fd85749e116baa74.svg";